export default {
	path: 'books',
	name: 'BookForm',
	component() {
		return import('@/components/book/BookForm.vue')
	},
	children: [
		{
			path: '',
			name: 'BookList',
			component() {
				return import('@/components/book/book/BookList.vue')
			},
		},
		{
			path: ':id',
			name: 'BookDetail',
			component() {
				return import('@/components/book/book/BookDetail.vue')
			},
		},
		{
			path: 'toBePub',
			name: 'BookToBePubList',
			component() {
				return import('@/components/book/bookToBePub/BookToBePubList')
			},
		},
		{
			path: 'toBePub/:id',
			name: 'BookToBePubDetail',
			component() {
				return import('@/components/book/bookToBePub/BookToBePubDetail.vue')
			},
		},
		{
			path: 'over',
			name: 'BookCarryingForwardList',
			component() {
				return import('@/components/book/bookCarryingForward/BookCarryingForwardList')
			},
		},
		{
			path: 'over/:id',
			name: 'BookCarryingForwardDetail',
			component() {
				return import('@/components/book/bookCarryingForward/BookCarryingForwardDetail.vue')
			},
		},
	],
}